module.exports = __webpack_public_path__ + "img/plug3.48b600cb.jpg";